export default "__VITE_ASSET__VzDbVZfQ__"